import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  saveSection,
  cancelSectionEdit,
} from "../../../reducers/sectionManagement/thunkActions";
import {
  sectionEditCopySelector,
  sectionEditSelector,
  isSectionEditValidSelector,
} from "../../../reducers/sectionManagement/selectors";

import { View } from "../../View";
import { CancelSaveActionButtons } from "../Common/CancelSaveActionButtons";

const LockComponent = () => {
  const dispatch = useDispatch();
  const sectionEdit = useSelector(sectionEditSelector);
  const sectionChanged = sectionEdit !== useSelector(sectionEditCopySelector);
  const isSectionValid = useSelector(isSectionEditValidSelector);

  const shouldDisableSave = () =>
    !sectionEdit || !sectionChanged || !isSectionValid;

  return (
    <View>
      <View>
        {sectionEdit && (
          <CancelSaveActionButtons
            onCancelClick={() => dispatch(cancelSectionEdit())}
            onSaveClick={() => dispatch(saveSection())}
            saveDisabled={shouldDisableSave()}
          />
        )}
      </View>
    </View>
  );
};

export default LockComponent;
